
import React from 'react';

class Footer extends React.Component {
    render() {
        return (

<>

  {/* ======= Footer ======= */}
  <footer id="footer" className="footer">
    <div className="footer-content">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="footer-info">
              <h3>I P M S</h3>
              <p>
                A108 29 May Street <br />
                SY 535022, Damascus
                <br /> 
                <br />
                <strong>Phone:</strong> +963 930 302 077
                <br />
                <strong>Email:</strong> info@IPMS.com
                <br />
              </p>
            </div>
          </div>
          <div className="col-lg-2 col-md-6 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li>
                <i className="bi bi-chevron-right" /> <a href="/">Home</a>
              </li>
              <li>
                <i className="bi bi-chevron-right" /> <a href="#">About us</a>
              </li>
              <li>
                <i className="bi bi-chevron-right" /> <a href="/Service">Services</a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a href="#">Terms of service</a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a href="#">Privacy policy</a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li>
                <i className="bi bi-chevron-right" /> <a href="#">Web Design</a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a href="#">Web Development</a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a href="#">Product Management</a>
              </li>
              <li>
                <i className="bi bi-chevron-right" /> <a href="#">Marketing</a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a href="#">Graphic Design</a>
              </li>
            </ul>
          </div>
          <div className="col-lg-4 col-md-6 footer-newsletter">
            <h4>Our Newsletter</h4>
            <ul>
            <li>
            <i className="bi bi-facebook" /> <a href="#">Facebook</a>
            </li>
            </ul>
            <ul>
            <li>
            <i className="bi bi-whatsapp" /> <a href="#">WhatsApp</a>
            </li>
            </ul>
            <ul>
            <li>
            <i className="bi bi-youtube" /> <a href="#">YouTube</a>
            </li>
            </ul>
            <ul>
            <li>
            <i className="bi bi-linkedin" /> <a href="#">Linkedin</a>
            </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
  {/* End Footer */}

<a
    href="#"
    className="scroll-top d-flex align-items-center justify-content-center"
  >
    <i className="bi bi-arrow-up-short" />
  </a>
  <div id="preloader" />


</>

        );
    }
}

export default Footer;